import { Drawer } from '@material-ui/core'
import List from '@material-ui/core/List'
import React from 'react'
import SidebarHeader from './components/SidebarHeader'

type SidebarType = ISideBar & ISidebarDispatch & ISidebarProps

function Sidebar({
                   children,
                   open,
                   closeDrawer,
                   elevation = 16,
                   headerIcon,
                   headerLabel,
                   scrollable = false,
                 }: SidebarType) {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={closeDrawer}
      ModalProps={{ BackdropProps: { invisible: true } }}
      elevation={elevation}
      style={{ maxHeight: 'var(--full)', userSelect: 'none' }}
    >
      <SidebarHeader
        icon={headerIcon}
        label={headerLabel}
        toggleSidebar={closeDrawer}
      />
      <List
        style={{
          height: '100%',
          maxHeight: '100%',
          maxWidth: '310px',
          overflowX: 'hidden',
          overflowY: scrollable ? 'auto' : 'hidden',
          paddingTop: '0px',
        }}
      >
        {children}
      </List>
    </Drawer>
  )
}

export default Sidebar

export interface ISideBar {
  children: JSX.Element | React.ReactNode
  elevation?: number
  headerIcon?: JSX.Element | React.ReactNode | null
  headerLabel?: string | null
  scrollable?: boolean
}

export interface ISidebarProps {
  open: boolean
}

export interface ISidebarDispatch {
  closeDrawer: () => void
}
